__turbopack_context__.v({
  "primaryTickerSymbol": "stock-info-module-scss-module__3vyyoG__primaryTickerSymbol",
});
